import * as React from 'react';
import { useResetPassword } from './useResetPassword';
import { ChooseEmailForm, ResetPasswordForm } from '@components/organisms';
import type { SelectEmailFormLabels } from '@components/organisms/choose-email-form';
import type { ResetPasswordLabels } from '@components/organisms/reset-password-form';

type Props = {
	labels: {
		chooseEmail: SelectEmailFormLabels;
		resetPassword: ResetPasswordLabels;
	};
	onPasswordReset: () => void;
	goBackToLogin: () => void;
};

export const ResetPassword: React.FC<Props> = ({ labels, onPasswordReset, goBackToLogin }) => {
	const { step, email, resendCode, handleResetPassword, sendResetPasswordRequest } = useResetPassword({
		onPasswordReset,
	});

	const CurrentStep = React.useMemo(() => {
		switch (step) {
			case 'choose-email':
				return (
					<ChooseEmailForm labels={labels.chooseEmail} onSubmit={sendResetPasswordRequest} goBack={goBackToLogin} />
				);
			case 'reset-password':
				return (
					<ResetPasswordForm
						email={email}
						labels={labels.resetPassword}
						onSubmit={handleResetPassword}
						resendCode={resendCode}
					/>
				);
		}
	}, [step, email, sendResetPasswordRequest, handleResetPassword, resendCode, goBackToLogin]);

	return <React.Fragment>{CurrentStep}</React.Fragment>;
};
